import React, { CSSProperties } from 'react';
import { Col, Input, Row } from 'antd';
import { Controller, useFormContext } from 'react-hook-form';

const RatesInput = (props: { name: string, style: CSSProperties }) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={props.name}
      render={({ field: { value, onChange } }) => {
        return (
          <Row style={props.style}>
            <Col span={8}>
              <Input
                addonBefore="Open Rate"
                max={100}
                min={0}
                type="number"
                value={value.open}
                onChange={e => {
                  onChange({
                    ...value,
                    open: parseFloat(e.target.value),
                  });
                }}
              />
            </Col>

            <Col span={8}>
              <Input
                addonBefore="Click Rate"
                max={100}
                min={0}
                type="number"
                value={value.click}
                onChange={e => {
                  onChange({
                    ...value,
                    click: parseFloat(e.target.value),
                  });
                }}
              />
            </Col>

            <Col span={8}>
              <Input
                addonBefore="Reply Rate"
                max={100}
                min={0}
                type="number"
                value={value.reply}
                onChange={e => {
                  onChange({
                    ...value,
                    reply: parseFloat(e.target.value),
                  });
                }}
              />
            </Col>
          </Row>
        );
      }}
    />
  );
};

export default RatesInput;
